// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuFilterEditor{align-items:center;gap:var(--salt-spacing-200);height:var(--vuuFilterEditor-height,calc(var(--salt-size-base) + var(--salt-size-unit)));grid-area:2/1/3/4;width:100%;display:flex}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
